function isValidCepMasked(value) {
    return /^\d{5}-\d{3}$/.test(value);
}
export function isValidCep(value) {
    if (!value)
        return false;
    if (isValidCepMasked(value))
        return true;
    return /^\d{8}$/.test(value);
}
